import { AGENT_API } from '../AgentAPI';
import { Branch, createBranch } from '@golden/gdk-base';
import { map } from 'rxjs';
import { convertUnixToDate } from '@golden/utils';
export function createAgentService(api, trunk) {
    return {
        me: createBranch({
            trunk,
            branch: Branch.ME,
            value: null,
            operator: () => api.fetch(AGENT_API.GET_AGENT_ME).pipe(map((data) => convertUnixToDate(data, 'created_at')))
        }),
        info: createBranch({
            trunk,
            branch: Branch.AGENT_INFO,
            value: {
                percentage: 0,
                agent_cash: '0.0000',
                unread_count: 0
            },
            operator: () => api.fetch(AGENT_API.GET_AGENT_ME_INFO)
        }),
        updateMe(data) {
            return api.fetch(AGENT_API.PUT_AGENT_ME, { data });
        },
        getHomeData() {
            return api.fetch(AGENT_API.GET_HOME).pipe(map((data) => convertUnixToDate(data, 'updated_at')));
        }
    };
}
//# sourceMappingURL=AgentService.js.map